import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
//jeb import { MDCSnackbar } from '@material/snackbar';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  @Input() public IsMatrixToolsWebPortfolio: boolean;
  public email = null;
  public password = null;

  constructor(private auth: AuthenticationService) { }

  ngOnInit() {
  }

  login() {    
    this.auth.login(this.email, this.password).subscribe((user) => {
      if (!user) {
        //jeb this.snackBar.open('Login Failed!', 'Please Try Again', { duration: 10000, horizontalPosition: 'center' });
        //const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));//jeb gotta redo the html, redo offer component ?
        //snackbar.open();
      } else {
        window.location.reload();
      }
    }, (error) => {
      console.error(error);

      //jeb this.snackBar.open('Login Failed!', 'Please Try Again', { duration: 10000, horizontalPosition: 'center' });
      //const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));//jeb gotta redo the html, redo offer component ?
      //snackbar.open();
    });
  }
}
